import React, { useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { RefreshIcon } from '../icons';
import Button from '../button';

export interface Tab {
  title: string;
  content: React.JSX.Element;
}

interface TabsProps {
  tabs: Tab[];
  hasRefresh?: boolean
  refreshHandle?: () => void;
}

const Tabs: React.FC<TabsProps> = ({ tabs, hasRefresh = false, refreshHandle = () => { } }) => {
  const [activeTab, setActiveTab] = useState(0); // tab index

  const onDdlKeyDown = (event: any, index:number) => {
    if (event.key === 'Enter') {
      setActiveTab(index)
    }
  }

  return (
    <div className="oms-frame">
      <Nav tabs card>
        {tabs.map((tab, index) =>
          <NavItem key={index} tabIndex={0} onKeyDown={(event) => onDdlKeyDown(event,index)}>
            <NavLink className="pe-force" active={index === activeTab}  onClick={() => setActiveTab(index)}>
              {tab.title}
            </NavLink>
          </NavItem>
        )}

        {hasRefresh &&
          <Button color="link" className="ms-auto" aria-label="Refresh" onClick={refreshHandle}>
            <RefreshIcon />
          </Button>
        }
      </Nav>

      <div className="oms-container p-3" >
        {tabs[activeTab].content}
      </div>
    </div>
  );
};

export default Tabs;
